import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form,
      labelAlign: "left"
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("保单号")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请输入") + _vm.$t("保单号")
    },
    model: {
      value: _vm.form.policyNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "policyNo", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.policyNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("产品名称")
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("产品名称"),
      "show-search": "",
      "option-filter-prop": "label"
    },
    model: {
      value: _vm.form.insuranceId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "insuranceId", $$v);
      },
      expression: "form.insuranceId"
    }
  }, _vm._l(_vm.productionSelectList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        label: item.name
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "topLeft",
        title: item.name
      }
    }, [_vm._v(_vm._s(item.name))])], 1);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("理赔结果")
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("理赔结果")
    },
    model: {
      value: _vm.form.result,
      callback: function ($$v) {
        _vm.$set(_vm.form, "result", $$v);
      },
      expression: "form.result"
    }
  }, _vm._l(_vm.resultSelectList, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key,
        label: item.name
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("结案状态")
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("结案状态")
    },
    model: {
      value: _vm.form.isClose,
      callback: function ($$v) {
        _vm.$set(_vm.form, "isClose", $$v);
      },
      expression: "form.isClose"
    }
  }, _vm._l(_vm.statusSelectList, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key,
        label: item.name
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("申请时间")
    }
  }, [_c("a-date-picker", {
    attrs: {
      format: _vm.getFormatDate()
    },
    on: {
      change: function ($event) {
        _vm.form.createAt = _vm.form.createAt ? _vm.form.createAt : "";
      }
    },
    model: {
      value: _vm.form.createAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "createAt", $$v);
      },
      expression: "form.createAt"
    }
  })], 1)], 1), _vm.showItem ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("审核状态")
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("审核状态")
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, _vm._l(_vm.auditSelectList, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key,
        label: item.name
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)) + " ")]);
  }), 1)], 1)], 1) : _vm._e(), _vm.showItem ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("保单来源")
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "label",
      placeholder: _vm.$t("请选择") + _vm.$t("保单来源")
    },
    model: {
      value: _vm.form.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "applicationId", $$v);
      },
      expression: "form.applicationId"
    }
  }, _vm._l(_vm.sourceSelectList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        label: item.name
      }
    }, [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.type == 1 ? "app" : item.type == 2 ? "h5" : item.type == 3 ? "pc" : _vm.$t("小程序")) + ") ")]);
  }), 1)], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-button", {
    attrs: {
      type: "linkSeach"
    },
    on: {
      click: function ($event) {
        _vm.tagShow = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("标签查询")))]), _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        _vm.showItem = !_vm.showItem;
      }
    }
  }, [_vm._v(_vm._s(_vm.showItem ? _vm.$t("收起查询条件") : _vm.$t("更多查询条件")))])], 1)], 1), _vm.tagList.length != 0 ? _c("a-row", [_c("a-form-item", {
    staticClass: "tagBox",
    attrs: {
      label: _vm.$t("已选择标签")
    }
  }, [_c("tag-list", {
    attrs: {
      tagList: _vm.tagList,
      tagData: _vm.tagData
    },
    on: {
      ok: _vm.tagListOk
    }
  })], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "marginT10"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.resetSearch
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))]), _vm.isAuth("customer.claimsRecordExport") ? _c("a-button", {
    on: {
      click: function ($event) {
        _vm.downloadShow = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("导出")))]) : _vm._e()], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      columns: _vm.columns,
      "data-source": _vm.tableData,
      bordered: "",
      pagination: _vm.pagination,
      rowKey: "id",
      defaultExpandAllRows: true
    },
    on: {
      change: _vm.tablePageChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (_, record, index) {
        return [_vm._v(_vm._s((_vm.pagination.current - 1) * _vm.pagination.pageSize + Number(index + 1)))];
      }
    }, {
      key: "tag",
      fn: function (text, record) {
        return [_c("click-show-tag", {
          attrs: {
            data: record.tagsData
          }
        }, [_c("span", {
          attrs: {
            slot: "icon"
          },
          slot: "icon"
        }, [_c("a-icon", {
          attrs: {
            type: "switcher"
          }
        })], 1)])];
      }
    }, {
      key: "claimsNode",
      fn: function (text, record) {
        return [_vm._v(" " + _vm._s(_vm._f("typeFilters")(record.claimsNode, record, _vm.tag, _vm.currentThis)) + " ")];
      }
    }, {
      key: "operation",
      fn: function (text, record) {
        return [_vm.isAuth("customer.claimsSchedule") ? _c("a-button", {
          attrs: {
            size: "small",
            type: "primary2"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "customerRecordManageProgress",
                params: {
                  id: record.id
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("理赔进度")) + " ")]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.downloadShow ? _c("download-model", {
    attrs: {
      previewVisible: _vm.downloadShow
    },
    on: {
      cancel: function ($event) {
        _vm.downloadShow = false;
      }
    }
  }) : _vm._e(), _c("tag-model", {
    attrs: {
      dialogVisible: _vm.tagShow,
      tagData: _vm.tagData,
      tagList: _vm.tagList
    },
    on: {
      cancel: function ($event) {
        _vm.tagShow = false;
      },
      ok: _vm.tagOk
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };